import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const getPartner23Commission=(token)=>async dispatch=>{
    dispatch({
        type:actionTypes.GET_PARTNER23C_START
    })
    const options={
        url:`${api}/partnerTwoThreeCommissions`,
        method:'GET',
        headers:{
            'Authorization':`Bearer ${token}`
        },
        data:{}
    }
    await axios(options)
            .then(response=>dispatch({
                type:actionTypes.GET_PARTNER23C_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.GET_PARTNER23C_FAIL,
                payload:getMessage(error)
            }))
}